export default __webpack_public_path__ + "3d60512ef78ea7d82c4cd9bbf20cb30b.ico";